import { TrueLayerDocumentRequirementContentDE } from './TrueLayerDocumentRequirementContentDE';
import { TrueLayerDocumentRequirementContentUK } from './TrueLayerDocumentRequirementContentUK';
import { useLocale } from '../../../../hooks/useLocale';

export const TrueLayerDocumentRequirementContent = () => {
  const { isDE } = useLocale();

  if (isDE) {
    return <TrueLayerDocumentRequirementContentDE />;
  }

  return <TrueLayerDocumentRequirementContentUK />;
};
